module.exports = __webpack_public_path__ + "static/media/074-kazakhstan.4f3f5b96.svg";